
import Vue from 'vue'
import Puff from './Puff.vue'
import { IHit } from '../store/state'

interface AppData {}

interface AppMethods {}

interface AppComputed {
    hits: IHit[]
}

interface AppProps {
}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
    name: 'List',
    computed: {
        hits() {
            return this.$store.getters.hits
        }
    },
    methods: {},
    components: {
        Puff
    }
})
